import emailjs from 'emailjs-com';
import React, { useState } from 'react';
import formImageOne from '../../../images/formImageOne.jpg'
import axios from 'axios';
// import { useForm } from "react-hook-form";
// import { Link } from 'react-router-dom';;

const ContactForm = () => {

  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_1hh9aod', 'template_7erbfh7', e.target, 'user_fKRJWT1HdvunM9ZM0WNnO')
      .then((result) => {
        console.log(result.text);
        console.log("email submitted successfully")
      }, (error) => {
        console.log(error.text);
      });
    e.target.reset()
  }

  return (
    <section>
      <div className="row align-items-center emailCard px-5 pb-5 pt-5">
        <div className="container col-md-6 shadow p-3">
          <form onSubmit={sendEmail}>
            <div className="col-sm-15">
              <h3 htmlFor="" className="text-center">Write Your Thinking</h3>
              <input type="text" name="name" placeholder="Your Name" class="form-control" id="inputPassword" />
            </div>
            <br />
            <div className="col-sm-15">
              <input type="email" name="email" placeholder="Your Email Address" class="form-control" id="inputPassword" />
            </div>
            <br />
            <div className="col-sm-15">
              <textarea name="message" placeholder="Tell Me What Are You Thinking" class="form-control" id="inputPassword" />
            </div>

            <br />
            {/* <input type="submit" /> */}
            <input class="btn btn-primary" type="submit" value="Send"></input>
          </form>
        </div>

        <div className="container col-md-6">
          <img className="img-fluid" src={formImageOne} alt="" />
        </div>
        <div />
      </div>
    </section>
  );
};

export default ContactForm;